angular
	.module('inputMobile.components', [])
	.component('inputMobile', {
		templateUrl: 'ng/components/inputMobile/inputMobile.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			formName: '=',
			bindingVariable: '=',
			/** Optional data **/
			checkUnique: '<',
			listaPf: '<',
			pfIdentifier: '@',
			inputDisableOn: '<',
			errorMsg: '@'
		},
		controllerAs: 'inputMobileCtrl',
		controller: function ($translate, validationService, verifyUniqueService) {

			/** not to loose *this reference **/
			var self = this;

			self.validationService = validationService;
			self.inputHasError = false;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;
				$('[data-toggle="tooltip"]').tooltip();

				self.onBlurFunction();
			}


			self.errorMsgShown = false;
			self.validationService = validationService;
			self.verifyUniqueService = verifyUniqueService;

			self.onBlurFunction = function () {
				if (self.checkUnique && self.bindingVariable && self.bindingVariable != '') {
					if (self.listaPf) {
						var isUnique = !self.listaPf.some(function (pf) {
							return pf.cf != self.pfIdentifier && pf.telefono == self.bindingVariable;
						});
						if (isUnique) {
							callVerifyService();
						} else {
							self.formName[self.inputName].$setValidity('unique', false);
						}
					} else {
						callVerifyService();
					}

					function callVerifyService() {
						self.verifyUniqueService.verifyAppUniqueItem({
								identifier: self.pfIdentifier,
								phone: self.bindingVariable
							})
							.then(function (response) {
								if (response.success) {
									if (response.unique) {
										self.formName[self.inputName].$setValidity('unique', true);
									} else {
										self.formName[self.inputName].$setValidity('unique', false);
									}
									self.formName[self.inputName].$invalid = !response.unique;
									self.formName[self.inputName].$valid = response.unique;
								}
							});
					}
				}
			}

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
			}

			self.isInvalid = function () {
				self.inputHasError = !self.formName[self.inputName].$pristine && (self.formName[self.inputName].$error.pattern || self.formName[self.inputName].$error.required);
			}

		}
	});